import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { ReadDepartment, WriteDepartment } from "@/types/department";

export const useDepartmentsDictionary = () => {
  const config = getDictionaryConfig<ReadDepartment, WriteDepartment>(
    Module.UpdatesDepartments,
  );
  return config;
};
